<script setup>
import { useI18n } from "vue-i18n";
import {inject} from "vue";
import getLocale from "@/locale";
const { t } = useI18n();

const locale = getLocale();

const isMenuOpen = inject('isMenuOpen');
</script>

<template>
  <div class="intro-wrapper">
    <div class="intro-container">
      <div class="logos" v-show="!isMenuOpen">
        <img src="../assets/icons/logos.svg" alt="Just Eat and Uefa Champions League Logo">
      </div>
      <div class="intro-content">
        <!-- Title Section -->
        <div :class="['intro-title', { 'intro-title-it': locale === 'it' }, { 'intro-title-es' : locale === 'es'}]">
          <h1 v-html="t('sectionOne.headline')"></h1>
        </div>
        <!-- Subline Section -->
        <div :class="['intro-subline', { 'intro-subline-en': locale === 'en' || locale === 'ie' }]">
          <h2>{{ t("sectionOne.subline")}}</h2>
          <p>{{t("sectionOne.body.text")}}<br><br>{{t("sectionOne.body.span")}}</p>
          <a :href="t('cta.orderNowLink')" target="_blank" class="btn-orderNow">{{ t("cta.orderNow") }}</a>
          <p class="smallPrint">{{ t("sectionOne.smallPrint") }}</p>
        </div>
      </div>
    </div>
      <div class="mobile-background-img">
        <img src="../assets/img/football-mob.png" alt="Football pitch with football player’s names written on it">
      </div>
  </div>
</template>

<style scoped>

h1 {
  font-size: clamp(48px, 10vw, 154px);
  font-weight: 1000;
  line-height: clamp(48px, 10vw, 138px);
  letter-spacing: -0.03em;
  margin: 0;
}

p{
  font-family: "JETSansVF2", Arial, sans-serif;
  font-size: clamp(13px, 2vw, 18px);
  font-weight: 400;
  line-height: 20px;
  color: #242E30;
}

::v-deep(.asterisk) {
  font-size: 0.6em;
  vertical-align: text-top;
  font-weight: 500;
}


.intro-wrapper {
  background: url("../assets/img/background-desktop.png") no-repeat center center / cover;
  max-height: 800px;
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding: 20px;
  box-sizing: border-box;
  position: relative;
}

.mobile-background-img {
  display: none;
  position: absolute;
  bottom: 0;
  width: 100%;
  max-height: 40vh;
  overflow: hidden;
}

.intro-title{
  padding-right: 20px;
}

.intro-title-es h1 {
    font-size: clamp(34px, 8vw, 100px);
    font-weight: 1000;
    line-height: clamp(40px, 8vw, 110px);
    letter-spacing: -0.03em;
    margin: 0;
}

.intro-title-it h1 {
  font-size: clamp(44px, 10vw, 132px);
  font-weight: 1000;
  line-height: clamp(44px, 10vw, 116px);
  letter-spacing: -0.03em;
  margin: 0;
}


.intro-subline {
  max-width: 470px;
  text-align: start;
  padding-right: 20px;
}

.intro-subline-en {
  max-width: 470px;
  text-align: start;
  padding-right: 20px;
  padding-bottom: 50px;
}


.intro-container {
  width: 45%;
  display: flex;
  flex-direction: column;
  gap: 10px;
  justify-content: space-between;
  margin-top: 30px;
}


.intro-content {
  width: 100%;
  padding-top: 10px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  text-align: left;
  overflow-wrap: break-word;
  }


.btn-orderNow {
  font-family: "JETSansVF2", Arial, sans-serif;
  width: 143px;
  height: 37px;
  background: #242e30;
  border: none;
  border-radius: 30px;
  color: #FAFAFA;
  font-size: 25px;
  font-weight: 800;
  font-style: italic;
  padding: 10px 35px 10px 35px;
  text-decoration: none;
}

.smallPrint {
  font-size: 10px;
  font-weight: 400;
  line-height: 12px;
  text-align: left;
  padding: 20px 0;
  margin: 0;
  max-width: 100%;
  word-wrap: break-word;
  overflow: hidden;
}

.logos {
  background: #FF8000;
  width: 188px;
  height: 85px;
  position: absolute;
  top: 0;
  left: 91%;
  transform: translateX(-60%);
  border-radius: 0 0 21px 21px;
  display: flex;
  justify-content: center;
  align-items: center;
  box-sizing: border-box;
}


.logos img {
  width: 147px;
  height: 66px;
}


@media only screen and (max-width: 768px) {
  .btn-orderNow {
    font-size: 20px;
    padding: 5px 15px 5px 15px;
  }

  .intro-wrapper {
    background: url('../assets/img/background.png') no-repeat center / cover;
    min-height: 950px;
    padding: 0;
    justify-content: center;
    position: relative;
    margin: 0 auto;
    align-items: flex-start;
  }

  .mobile-background-img {
    display: block;
    position: absolute;
    bottom: 0;
    width: 100%;
    max-height: 40vh;
  }

  .mobile-background-img img {
    width: 100%;
    height: auto;
    display: block;
    object-fit: contain;
  }

  .intro-content {
    display: flex;
    text-align: center;
    align-items: center;
    justify-content: center;
    width: auto;
    margin-top: 35px;
  }

  .intro-subline {
    align-items: center;
    text-align: center;
    width: 244px;
    padding: 0;
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
  }

  .intro-title {
    width: 282px;
    padding: 0;
  }


  .intro-title-it h1,
  .intro-title-es h1 {
    padding-top: 50px;
  }

  .smallPrint{
    padding: 10px 0;
  }

  h1 {
    font-size: 74px;
    line-height: 57px;
  }

  h2 {
    font-size: 20px;
    line-height: 20px;
  }

  p {
    font-size: 12px;
    font-weight: 700;
    line-height: 11px;
  }

  .btn-orderNow {
    width: 124px;
    height: 31px;
    border-radius: 25px;
  }

  .logos {
    position: absolute;
    top: 0;
    left: 50%;
    transform: translateX(-50%);
    width: 127px;
    height: 59px;
    margin: 0 auto 20px auto;
    background: #FF8000;
  }

  .logos img {
    width: 105px;
    height: 47px;
  }

}

</style>